import React from "react";
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";
import { GetApp } from "@mui/icons-material";
import { ButtonContactGreen } from "assets/jss/material-dashboard-react/components/cardBodyStyle";
import dayjs from "dayjs";

const ExcelProductsTotalReport = ({
  fromDate,
  toDate,
  excelData = [],
  fileName,
  disabled,
}) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  // Transformar los datos para Excel
  const transformDataForExcel = (excelData) => {
    const transformedData = [];

    // Validar que excelData sea un array y no esté vacío
    if (!Array.isArray(excelData)) {
      console.error("Error: excelData no es un array válido.");
      return transformedData;
    }

    excelData.forEach((product) => {
      // Validar que el producto tenga la propiedad dataSelect
      if (!product?.dataSelect || !Array.isArray(product.dataSelect)) {
        console.error("Error: product.dataSelect no es un array válido.");
        return;
      }

      // Agregar una fila para el nombre del producto
      transformedData.push({
        PRODUCTOS: product.name,
        TIPO: "",
        Registros: "",
        "Sumatoria $": "",
      });

      // Agregar filas para cada registro interno (dataSelect)
      product.dataSelect.forEach((data) => {
        transformedData.push({
          PRODUCTOS: "", // Dejar vacío para indicar que pertenece al producto anterior
          TIPO: data.name,
          Registros: parseFloat(data.count),
          "Sumatoria $": parseFloat(data.priceTotal),
        });
      });

      // Agregar una fila vacía para separar productos
      transformedData.push({});
    });

    return transformedData;
  };

  const exportToExcel = () => {
    // Transformar los datos
    const dataToExport = transformDataForExcel(excelData);

    // Validar que haya datos para exportar
    if (dataToExport.length === 0) {
      console.error("No hay datos para exportar.");
      return;
    }

    // Crear una hoja de cálculo vacía
    const ws = XLSX.utils.aoa_to_sheet([]);

    // Agregar el rango de fechas en la primera fila (combinando 4 columnas)
    //if (fromDate && toDate) {
    XLSX.utils.sheet_add_aoa(
      ws,
      [
        [
          fromDate && toDate
            ? `RANGO DE CONSULTA DESDE: ${dayjs(fromDate).format(
                "DD-MM-YYYY"
              )} - HASTA: ${dayjs(toDate).format("DD-MM-YYYY")}`
            : "LISTADO DE PRODUCTOS SIN RANDO DE CONSULTA",
        ],
      ],
      { origin: "A1" }
    );

    // Combinar las celdas de la primera fila (A1:D1)
    if (!ws["!merges"]) ws["!merges"] = [];
    ws["!merges"].push({ s: { r: 0, c: 0 }, e: { r: 0, c: 3 } }); // Combinar A1:D1
    // }

    // Agregar los datos transformados a partir de la segunda fila
    XLSX.utils.sheet_add_json(ws, dataToExport, {
      origin: "A2",
      skipHeader: false,
    });

    // Definir el estilo de los bordes
    const borderStyle = {
      top: { style: "thin", color: { rgb: "000000" } },
      bottom: { style: "thin", color: { rgb: "000000" } },
      left: { style: "thin", color: { rgb: "000000" } },
      right: { style: "thin", color: { rgb: "000000" } },
    };

    // Estilo para el encabezado
    const headerStyle = {
      fill: {
        fgColor: { rgb: "003366" }, // Fondo azul oscuro
      },
      font: {
        color: { rgb: "FFFFFF" }, // Letras blancas
        bold: true, // Texto en negrita
      },
      alignment: {
        horizontal: "center", // Alinear texto al centro
      },
      border: borderStyle, // Bordes
    };

    // Aplicar bordes y estilos a todas las celdas
    const range = XLSX.utils.decode_range(ws["!ref"]);
    for (let row = range.s.r; row <= range.e.r; row++) {
      for (let col = range.s.c; col <= range.e.c; col++) {
        const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
        if (!ws[cellAddress]) {
          ws[cellAddress] = { v: "", t: "s" }; // Crear celda vacía si no existe
        }
        ws[cellAddress].s = { border: borderStyle }; // Aplicar bordes

        // Aplicar estilo al encabezado (segunda fila, ya que la primera es el rango de fechas)
        if (row === 1) {
          ws[cellAddress].s = { ...ws[cellAddress].s, ...headerStyle };
        }
      }
    }

    // Ajustar el ancho de las columnas
    const columnWidths = [
      { wch: 30 }, // Ancho para la columna "Producto"
      { wch: 30 }, // Ancho para la columna "Registros"
      { wch: 15 }, // Ancho para la columna "Total Registros"
      { wch: 15 }, // Ancho para la columna "Sumatoria Total"
    ];
    ws["!cols"] = columnWidths;

    // Crear el libro de trabajo y guardar el archivo
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  return (
    <>
      <ButtonContactGreen
        onClick={exportToExcel}
        startIcon={<GetApp style={{ fontSize: 14 }} />}
        disabled={disabled}
        style={{ fontSize: 12 }}
      >
        Excel
      </ButtonContactGreen>
    </>
  );
};

export default ExcelProductsTotalReport;
